import { ArtBoardNS } from "../../../../ArtBoard/ArtBoardNS.js";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
export class Background {
  constructor({ value, art_board }) {
    this._observer_set = new Set();
    this._width = 0;
    this._height = 0;
    this._value = value;
    art_board.subscribe((vo) => this._observeArtBoard(vo));
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer({
      width: this._width,
      height: this._height,
      value: this._value.toVO(),
    });
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  setValue(value) {
    this._value = value;
    this._notify({
      width: this._width,
      height: this._height,
      value: this._value.toVO(),
    });
  }
  toVO() {
    return {
      width: this._width,
      height: this._height,
      value: this._value.toVO(),
    };
  }
  _observeArtBoard({ width, height }) {
    this._width = width;
    this._height = height;
    this._notify({
      width: this._width,
      height: this._height,
      value: this._value.toVO(),
    });
  }
  _notify(background_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(background_vo));
    }
  }
}
